import mediaService from '../api/media'

const state = {
    mediasImages: {}
}

const getters = {

}

const actions = {
    getMediaImages ({ commit, state }, mediaId) {
        const requestId = 'GET_MEDIA_IMAGES_' + mediaId

        commit('ui/enableLoader', requestId, { root: true })

        if (state.mediasImages[mediaId]) {
            commit('ui/disableLoader', requestId, { root: true })
            return state.mediasImages[mediaId]
        }

        return mediaService.getMediaImageUrls(mediaId).then(response => {
            const images = response.data

            if (typeof images === 'object' && Object.keys(images).length > 0) {
                commit('setMediaImages', { id: mediaId, images: images })

                // also fetch the file thumbnails in the file store
                for (const fileId in images) {
                    if (images.hasOwnProperty(fileId)) {
                        commit('file/setFileThumbnails', { id: fileId, thumbnails: images[fileId] }, { root: true })
                    }
                }

                return images
            }

            return false
        }, () => false).finally(() => commit('ui/disableLoader', requestId, { root: true }))
    }
}

const mutations = {
    setMediaImages (state, { id, images }) {
        state.mediasImages = {
            ...state.mediasImages,
            [id]: images,
        }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
